import {
    DATA_MANAGEMENT_STATISTICS_REQUEST,
    DATA_MANAGEMENT_STATISTICS_SUCCESS,
    DATA_MANAGEMENT_STATISTICS_FAIL,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL,
    DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL,
    DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL,
    DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL,
    DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL,
    DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET,
    DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST,
    DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS,
    DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL,
    DATA_MANAGEMENT_CLEAR_PATIENTS_RESET,
} from '../constants/dataManagementConstants';

export const dataManagementStatisticsReducer = (state = { loading: false, statistics: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_STATISTICS_REQUEST:
            return { loading: true, statistics: null, error: null };
        case DATA_MANAGEMENT_STATISTICS_SUCCESS:
            return { loading: false, statistics: action.payload, error: null };
        case DATA_MANAGEMENT_STATISTICS_FAIL:
            return { loading: false, statistics: null, error: action.payload };
        default:
            return state;
    }
};

export const dataManagementPreviewSubjectsReducer = (state = { loading: false, count: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST:
            return { loading: true, count: null, error: null };
        case DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS:
            return { loading: false, count: action.payload.count, error: null };
        case DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL:
            return { loading: false, count: null, error: action.payload };
        case DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET:
            return { loading: false, count: null, error: null };
        default:
            return state;
    }
};

export const dataManagementPreviewUploadBatchesReducer = (state = { loading: false, count: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST:
            return { loading: true, count: null, error: null };
        case DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS:
            return { loading: false, count: action.payload.count, error: null };
        case DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL:
            return { loading: false, count: null, error: action.payload };
        case DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET:
            return { loading: false, count: null, error: null };
        default:
            return state;
    }
};

export const dataManagementPreviewPatientsReducer = (state = { loading: false, count: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST:
            return { loading: true, count: null, error: null };
        case DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS:
            return { loading: false, count: action.payload.count, error: null };
        case DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL:
            return { loading: false, count: null, error: action.payload };
        case DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET:
            return { loading: false, count: null, error: null };
        default:
            return state;
    }
};

export const dataManagementClearSubjectsReducer = (state = { loading: false, success: false, message: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST:
            return { loading: true, success: false, message: null, error: null };
        case DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS:
            return { loading: false, success: true, message: action.payload.message, error: null };
        case DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL:
            return { loading: false, success: false, message: null, error: action.payload };
        case DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET:
            return { loading: false, success: false, message: null, error: null };
        default:
            return state;
    }
};

export const dataManagementClearUploadBatchesReducer = (state = { loading: false, success: false, message: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST:
            return { loading: true, success: false, message: null, error: null };
        case DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS:
            return { loading: false, success: true, message: action.payload.message, error: null };
        case DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL:
            return { loading: false, success: false, message: null, error: action.payload };
        case DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET:
            return { loading: false, success: false, message: null, error: null };
        default:
            return state;
    }
};

export const dataManagementClearPatientsReducer = (state = { loading: false, success: false, message: null, error: null }, action) => {
    switch (action.type) {
        case DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST:
            return { loading: true, success: false, message: null, error: null };
        case DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS:
            return { loading: false, success: true, message: action.payload.message, error: null };
        case DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL:
            return { loading: false, success: false, message: null, error: action.payload };
        case DATA_MANAGEMENT_CLEAR_PATIENTS_RESET:
            return { loading: false, success: false, message: null, error: null };
        default:
            return state;
    }
};


